import { number, oneOfType, string } from "prop-types";

/* An icon's size is px from a caller that knows it, or "1em" from CustomIcon,
   which sizes every custom icon off its text the way an fa icon is. */
export const cssLength = (size) =>
  typeof size === "number" ? `${size}px` : size;

export const scaleLength = (size, factor) =>
  typeof size === "number" ? `${size * factor}px` : `calc(${size} * ${factor})`;

export const iconSizeType = oneOfType([number, string]);
